import { render, staticRenderFns } from "./TaxPph22.vue?vue&type=template&id=2eec03ca"
import script from "./TaxPph22.vue?vue&type=script&lang=js"
export * from "./TaxPph22.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports